import { Mail, Phone } from "lucide-react";
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";

// Contact utility bar shown above the main navigation, on black so the white
// nav row below keeps its contrast.
const CONTACT = {
  email: "info@terces.io",
  phoneDisplay: "+91 9281115822",
  phoneTel: "tel:+919281115822",
  whatsapp: "https://wa.me/919281115822",
};

const SOCIALS = [
  { icon: FaInstagram, href: "https://www.instagram.com/terces_solutions/", label: "Instagram" },
  { icon: FaFacebook, href: "https://www.facebook.com/Terces1555", label: "Facebook" },
  { icon: FaLinkedin, href: "https://www.linkedin.com/company/105919678/", label: "LinkedIn" },
];

const TopNav = () => {
  return (
    <div style={{ backgroundColor: "#000000" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-9 text-[13px] text-white/90">
          {/* Left — direct contact */}
          <div className="flex items-center gap-5 min-w-0">
            <a
              href={`mailto:${CONTACT.email}`}
              className="flex items-center gap-2 text-white/90 hover:text-white transition-colors truncate"
            >
              <Mail className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={2} />
              <span className="truncate">{CONTACT.email}</span>
            </a>
            <a
              href={CONTACT.phoneTel}
              className="hidden sm:flex items-center gap-2 text-white/90 hover:text-white transition-colors"
            >
              <Phone className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={2} />
              {CONTACT.phoneDisplay}
            </a>
          </div>

          {/* Right — WhatsApp + socials */}
          <div className="flex items-center">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/90 hover:text-white transition-colors"
            >
              <FaWhatsapp className="w-4 h-4 flex-shrink-0 text-[#25D366]" />
              <span className="hidden md:inline">Chat on WhatsApp</span>
            </a>

            <span className="w-px h-4 bg-white/25 mx-4" aria-hidden="true" />

            <div className="flex items-center gap-4">
              {SOCIALS.map(({ icon: SocialIcon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  <SocialIcon className="w-3.5 h-3.5" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
